import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

import { DescargaFicheroConcesionarioDownloadComponent } from "./descarga-fichero-concesionario-download/descarga-fichero-concesionario-download.component";
import { DescargaFicheroConcesionarioComponent } from "./descarga-fichero-concesionario.component";

const routesUser: Routes = [
  {
    path: "",
    component: DescargaFicheroConcesionarioComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "download",
        component: DescargaFicheroConcesionarioDownloadComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesUser)],
  exports: [RouterModule],
})
export class DescargaFicheroConcesionarioRoutingModule {}
